import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CustomContainer from '../../components/CustomContainer';
import ProductGrid from '../Products/Components/ProductGrid';
import PartnerCatalogHero from './Hero';
import { useQuery } from '@tanstack/react-query';
import { getCustomerCatalog } from '../../helpers/httpRequests/customer';
import LoadingComponent from '../../components/LoadingComponent';
import EmptyState from '../../components/EmptyState';
import AppCard from '../../components/ui/AppCard';
import { Box } from '@mui/material';

function catalogRecord(data) {
    const payload = data?.data?.data ?? data?.data ?? data ?? {};
    return Array.isArray(payload) ? payload[0] || {} : payload;
}

function whatsappHref(rawPhone, message) {
    const digits = String(rawPhone || '').replace(/\D/g, '');
    if (!digits) return null;
    const phone = digits.startsWith('55') ? digits : `55${digits}`;
    return `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
}

export default function CustomStoreCatalog() {
    const { slug } = useParams();

    const { data, isError, isFetching } = useQuery({
        queryKey: ['getCustomerCatalog', slug],
        queryFn: () => getCustomerCatalog(slug),
        staleTime: 1000 * 60 * 60,
        enabled: Boolean(slug),
    });

    const customer = catalogRecord(data);
    const name = customer.name || customer.complete_name || '';
    const storeWhatsapp = whatsappHref(
        customer.whatsapp || customer.whatsapp_number,
        name ? `Olá, vim pelo catálogo de ${name} e gostaria de saber mais.` : 'Olá, gostaria de saber mais.',
    );

    if (!slug || isError) {
        return (
            <Box sx={styles.page}>
                <CustomContainer>
                    <Box sx={{ py: 8 }}>
                        <AppCard>
                            <EmptyState
                                title="Página não encontrada"
                                description="Esse endereço não está disponível."
                            />
                        </AppCard>
                    </Box>
                </CustomContainer>
            </Box>
        );
    }

    if (isFetching) {
        return <LoadingComponent />;
    }

    return (
        <Box sx={styles.page}>
            <Helmet>
                <title>{name || 'Joias'}</title>
            </Helmet>
            <PartnerCatalogHero
                name={name}
                image={customer.image}
                whatsappHref={storeWhatsapp}
            />
            <CustomContainer>
                <ProductGrid
                    isCustomerStoreGrid
                    customerData={{ ...customer, name, whatsappHref: storeWhatsapp }}
                />
            </CustomContainer>
        </Box>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
    },
};
